import React from 'react'

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">

      <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">
          Privacy Policy
        </h1>
        <p className="text-gray-600 mb-8">
          <strong>Effective Date:</strong> February 13, 2026
        </p>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 space-y-6 text-gray-700">
          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              1. Information We Collect
            </h3>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Student education records</li>
              <li>IEP documentation</li>
              <li>Limited health-related information</li>
              <li>User account information</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              2. How We Use Information
            </h3>
            <p>
              Provide IEP services, comply with legal obligations, and maintain
              security. We do not sell Student Data.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              3. Legal Basis
            </h3>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>FERPA School Official exception</li>
              <li>HIPAA Business Associate where applicable</li>
              <li>Contractual obligations</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              4. Data Sharing
            </h3>
            <p>
              No sharing except authorized personnel, approved subprocessors, or
              legal requirement.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              5. Security
            </h3>
            <p>Encryption, access controls, logging, secure hosting.</p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              6. Parent and Student Rights
            </h3>
            <p>Requests must be directed to the School.</p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              7. Contact
            </h3>
            <p>
              For questions about this Privacy Policy, please contact us at{' '}
              <a
                href="mailto:privacy@trackiep.com"
                className="text-blue-600 hover:text-blue-700 underline"
              >
                privacy@trackiep.com
              </a>
            </p>
          </section>
        </div>
      </main>

    </div>
  )
}

export default PrivacyPolicy
